// extracted by mini-css-extract-plugin
module.exports = {"form":"PSCRecordList_form__1VJsk","content":"PSCRecordList_content__1I8dl","contentMain":"PSCRecordList_contentMain__1pLHE","select":"PSCRecordList_select__24gBD"};